import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  SUBSCRIPTION_USAGE_FETCH,
  SUBSCRIPTION_USAGE_RECEIVE,
  ALL_USAGES_FETCH,
  ALL_USAGES_RECEIVE,
  INITIALIZE_ALL_USAGES,
  INITIALIZE_SUBSCRIPTION_USAGE,
  USAGES_RECEIVE_ERROR,
} from './constants';

const initialState = fromJS({
  fetching: false,
  fetchingUsage: false,
  billingPeriods: null,
  entities: {},
  result: [],
  error: null,
  allUsagesData: null,
  subscriptionUsage: null,
});

export const reducer = handleActions({

  [ALL_USAGES_FETCH]: (state) => (
    state
      .set('fetchingUsage', true)
  ),

  [INITIALIZE_ALL_USAGES]: (state) => (
    state
      .set('fetchingUsage', true)
  ),

  [INITIALIZE_SUBSCRIPTION_USAGE]: (state) => (
    state
      .set('fetchingUsage', true)
  ),

  [ALL_USAGES_RECEIVE]: (state, action) => (
    state
      .set('fetchingUsage', false)
      .set('error', null)
      .set('allUsagesData', fromJS(action.payload.entities))
  ),

  [SUBSCRIPTION_USAGE_FETCH]: (state) => (
    state
      .set('fetchingUsage', true)
  ),

  [SUBSCRIPTION_USAGE_RECEIVE]: (state, action) => (
    state
      .set('fetchingUsage', false)
      .set('error', null)
      .set('subscriptionUsage', fromJS(action.payload.entities))
  ),

  [USAGES_RECEIVE_ERROR]: (state) => (
    state
      .set('fetchingUsage', false)
  ),
}, initialState);

export default reducer
